import React, { useEffect, useState } from "react";
import { EPAPER_BANNER_TEXT } from "../../../constants";

import "./new-body-banner.m.css";

const EPAPER_BASE_URL = "https://epaper.prajavani.net/subscribe";

const buildEpaperUrl = (utmMedium) => {
  // ✅ Guaranteed order:
  // utm_source → utm_medium → utm_campaign
  return `${EPAPER_BASE_URL}?utm_source=pvsite&utm_medium=${utmMedium}&utm_campaign=awareness`;
};

const NewBodyWidget = () => {
  const [isMobile, setIsMobile] = useState(false);

  const epaperUrl = buildEpaperUrl("inarticle");

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const handleAnalytics = () => {
    if (typeof window !== "undefined" && window.dataLayer && typeof pushEventToDataLayer === "function") {
      pushEventToDataLayer("ePaper_banner");
    }
  };

  const desktopImage = "https://tpml-sites.s3.ap-south-1.amazonaws.com/images/pv_dsktp_article.png";
  const mobileImage = "https://tpml-sites.s3.ap-south-1.amazonaws.com/images/pv_mw_article.png";

  return (
    <a
      href={epaperUrl}
      target="_blank"
      rel="noopener noreferrer"
      styleName="epaper-banner"
      onClick={handleAnalytics}
      style={{ height: isMobile ? "74px" : "103px", overflow: "hidden" }}
    >
      <div styleName="epaper-left">
        <img src={isMobile ? mobileImage : desktopImage} alt="E-paper on multiple devices" styleName="epaper-device" />

        <div styleName="epaper-text">
          <h2 styleName="epaper-heading">
            <span>
              {EPAPER_BANNER_TEXT.PAPER_BANNER_HEADING_1} {EPAPER_BANNER_TEXT.PAPER_BANNER_HEADING_2}
            </span>
          </h2>

          <p styleName="epaper-subheading">{EPAPER_BANNER_TEXT.PAPER_BANNER_SUBHEADING}</p>
        </div>
      </div>

      <div styleName="epaper-cta">
        <span className="hide-mobile">ಈಗಲೇ ಚಂದಾದಾರರಾಗಿ</span>
        <span className="hide-desktop">ಚಂದಾದಾರರಾಗಿ</span>
      </div>
    </a>
  );
};

export default NewBodyWidget;
